import { useEffect, useRef, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { appsFor, AppIcon } from '@hana/ui';
import { completeSignIn } from '../auth';
import { IC, Stroke } from './Icons';
import { ThemeButton } from './Login';
import { AuthShell } from './Shell';
import s from './Login.module.css';

// /auth/callback — Microsoft trả về đây. Board Mint-Hub view `back`: "Đang mở <vùng>…" rồi vào đúng vùng.
export function Callback() {
  const nav = useNavigate();
  const [ret, setRet] = useState<string | null>(null);
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return; // StrictMode gọi effect 2 lần ở dev
    once.current = true;
    void completeSignIn().then((r) => {
      if (!r.ok) {
        if (r.reason === 'none') return void nav({ to: '/', search: {}, replace: true });
        return void nav({ to: '/', search: { err: r.reason }, replace: true });
      }
      const app = appsFor(true).find((a) => a.key === r.ret);
      if (!app) return void nav({ to: '/home', replace: true });
      setRet(app.key);
      location.replace(app.path);
    });
  }, [nav]);

  const app = appsFor(true).find((a) => a.key === ret);
  return (
    <AuthShell top={<ThemeButton />}>
      <main className={s.card} aria-labelledby="hbT">
        {app && (
          <div className={s.ret}>
            <AppIcon app={app.key} size={28} />
            <span>{app.name}</span>
          </div>
        )}
        <span className={`${s.badge} ${s.badgeOk}`} aria-hidden="true">
          <Stroke d={IC.check} size={24} w={2.2} />
        </span>
        <h1 id="hbT" role="status" className={s.title2}>
          {app ? `Đang mở ${app.name}…` : 'Đang hoàn tất đăng nhập…'}
        </h1>
        {app && (
          <>
            <a className={s.sso} href={app.path}>
              Mở ngay
              <Stroke d={IC.next} size={16} w={2} />
            </a>
            <a className={s.btn2} href="/home">
              <Stroke d={IC.grid} size={16} w={1.8} />
              Chọn vùng khác
            </a>
          </>
        )}
      </main>
    </AuthShell>
  );
}
